import axios from "axios";

interface ApiResponse {
  data: any[];
  status: string;
}

const API_BASE_URL =
  window.location.hostname === "localhost"
    ? "http://localhost/api_server"
    : "https://www.ppkm.org.my/api_server";

const getRows = async () => {
  try {
    const { data } = await axios.get<ApiResponse>(
      `${API_BASE_URL}/get_events/`
    );
    return data;
  } catch (error) {
    return error;
  }
};

const getEventCategories = async () => {
  try {
    const { data } = await axios.get<ApiResponse>(
      `${API_BASE_URL}/get_event_categories/`
    );
    return data;
  } catch (error) {
    return error;
  }
};

const saveRow = async (payload: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/submit_edit_events/`,
      payload
    );
    console.log(data)
    return data;
  } catch (error) {
    return error;
  }
};

const saveRowEventCategory = async (payload: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/submit_edit_event_category/`,
      payload
    );
    return data;
  } catch (error) {
    return error;
  }
};

const deleteEventRow = async (rowId: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/submit_delete_event/`,
      rowId
    );
    return data;
  } catch (error) {
    return error;
  }
};

const publishEventRow = async (rowId: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/submit_publish_event/`,
      rowId
    );
    return data;
  } catch (error) {
    return error;
  }
};

const deleteEventCategoryRow = async (rowId: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/submit_delete_event_category/`,
      rowId
    );
    return data;
  } catch (error) {
    return error;
  }
};

const createEvent = async (data: any) => {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  try {
    const response = await axios.post(
      `${API_BASE_URL}/submit_event/`,
      data,
      config
    );

    return response.data;
  } catch (error) {
    console.log("API request failed:", error);
  }
};

const createMeeting = async (data: any) => {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  try {
    const response = await axios.post(
      `${API_BASE_URL}/submit_meeting/`,
      data,
      config
    );

    return response.data;
  } catch (error) {
    console.log("API request failed:", error);
  }
};

const createAnnouncement = async (data: any) => {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  try {
    const response = await axios.post(
      `${API_BASE_URL}/submit_announcement/`,
      data,
      config
    );

    return response.data;
  } catch (error) {
    console.log("API request failed:", error);
  }
};

const getMemberType = async () => {
  try {
    const { data } = await axios.get(`${API_BASE_URL}/get_member_type/`);
    return data;
  } catch (error) {}
};

const saveRowSubCol = async (payload: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/submit_edit_event_fees/`,
      payload
    );
    return data;
  } catch (error) {
    console.log("API request failed:", error);
  }
};

const getEventEmailRecipientByMemberType = async (datas: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/get_event_email_recipient_by_member_type/`,
      datas,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return data;
  } catch (error) {
    console.log("API request failed:", error);
  }
};

const getCommitteeRecipients = async () => {
  try {
    const { data } = await axios.post(
      `${API_BASE_URL}/get_committee_email_recipients/`
    );
    return data;
  } catch (error) {
    console.log("API request failed:", error);
  }
};

const getCommitteeMembers = async () => {
  try {
    const { data } = await axios.post(
      `${API_BASE_URL}/get_committee_members/`
    );
    return data;
  } catch (error) {
    console.log("API request failed:", error);
  }
};

const getSecretariatMembers = async () => {
  try {
    const { data } = await axios.post(
      `${API_BASE_URL}/get_secretariat_members/`
    );
    return data;
  } catch (error) {
    console.log("API request failed:", error);
  }
};

const getEventEmailRecipient = async () => {
  try {
    const { data } = await axios.post(
      `${API_BASE_URL}/get_event_email_recipient/`
    );

    return data;
  } catch (error) {
    console.log("API request failed:", error);
  }
};
const getEventInfo = async (payload: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/get_event_info/`,
      payload
    );
    return data;
  } catch (error) {
    return error;
  }
};

const getEditEventInfo = async (payload: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/get_edit_event_info/`,
      payload
    );
    return data;
  } catch (error) {
    return error;
  }
};

const UpdateEventRegistrationInfo = async (payload: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/submit_edit_event_registration_info/`,
      payload
    );
    // console.log(data)
    return data;
  } catch (error) {
    return error;
  }
};

const getEventRegistrationInfo = async (rowId: any) => {
  try {
    const { data } = await axios.post(
      `${API_BASE_URL}/get_event_registration_info/`,
      rowId,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    // console.log(data)
    return data;
  } catch (error) {}
};

const getEventRegistrationInfoExcel = async (rowId: any) => {
  try {
    const { data } = await axios.post(
      `${API_BASE_URL}/get_event_registration_info_excel/`,
      rowId,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return data;
  } catch (error) {}
};

const deleteEventRegistrationRow = async (rowId: any) => {
  try {
    const { data } = await axios.post(
      `${API_BASE_URL}/delete_event_registration_row/`,
      rowId,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    // console.log(data)
    return data;
  } catch (error) {}
};

const updateEventRegistrationPaymentInfo = async (rowId: any) => {
  try {
    const { data } = await axios.post(
      `${API_BASE_URL}/update_event_registration_payment_info/`,
      rowId,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return data;
  } catch (error) {}
};

const sendEventRegistrationPaymentReminder = async (rowId: any) => {
  try {
    const { data } = await axios.post(
      `${API_BASE_URL}/event_registration_payment_reminder/`,
      rowId,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return data;
  } catch (error) {}
};

const uploadImage = async (base64Image: string): Promise<string | null> => {
  try {
    // Extract only Base64 data
    const match = base64Image.match(/data:image\/[^;]+;base64,([^"]+)/);
    if (!match) return null;

    const base64Data = match[1];
    const blob = await fetch(`data:image/png;base64,${base64Data}`).then((res) => res.blob());

    // Prepare FormData
    const formData = new FormData();
    formData.append("file", blob, "uploaded_image.png");

    // Upload to your PHP API
    const response = await axios.post(
      `${API_BASE_URL}/uploadImage/`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    // Return uploaded image URL
    if (response.data.status === "success") {
      return response.data.url;
    } else {
      console.error("Image upload failed:", response.data.message);
      return null;
    }
  } catch (error) {
    console.error("Error uploading image:", error);
    return null;
  }
};


const blastEvent = async (data: any) => {
  // console.log(emails)
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  try {
    const response = await axios.post<ApiResponse>(`${API_BASE_URL}/blast_event/`, data,config);
    console.log(response.data)
    return response.data;
  } catch (error) {
    return error;
  }
};

const getEventBlastDate = async (eventID: any) => {
  const payload = {
    eventID: eventID,
  };
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/get_event_blast_date/`,
      payload
    );

    return data;
  } catch (error) {
    return error;
  }
};

const saveEventEmailContent = async (payload: any) => {
  try {
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };

    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/save_event_email_content/`,
      payload,
      config
    );
    return data;
  } catch (error) {
    return error;
  }
};

const registerEventNonMember = async (emails: any) => {
  try {
    const { data } = await axios.post(
      `${API_BASE_URL}/register_event_non_member/`,
      emails
    );
    console.log(data)
    return data;
  } catch (error) {}
};

const getBlastHistory = async () => {
  try {
    const { data } = await axios.get<ApiResponse>(
      `${API_BASE_URL}/get_blast_history/`
    );
    return data;
  } catch (error) {
    return error;
  }
};

const getBlastHistoryInfo = async (payload: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/get_blast_history_info/`,
      payload
    );
    // console.log(data)
    return data;
  } catch (error) {
    return error;
  }
};

const deleteBlastHistory = async (id: any) => {
  try {
    const { data } = await axios.post(
      `${API_BASE_URL}/delete_blast_history/`,
      id
    );
    return data;
  } catch (error) {}
};

const EventController = {
  getRows,
  saveRow,
  getEventCategories,
  saveRowEventCategory,
  deleteEventRow,
  publishEventRow,
  deleteEventCategoryRow,
  createEvent,
  createMeeting,
  createAnnouncement,
  getMemberType,
  saveRowSubCol,
  getEventEmailRecipientByMemberType,
  getCommitteeRecipients,
  getCommitteeMembers,
  getSecretariatMembers,
  getEventEmailRecipient,
  getEventInfo,
  getEditEventInfo,
  UpdateEventRegistrationInfo,
  getEventRegistrationInfo,
  getEventRegistrationInfoExcel,
  deleteEventRegistrationRow,
  updateEventRegistrationPaymentInfo,
  sendEventRegistrationPaymentReminder,
  uploadImage,
  blastEvent,
  getEventBlastDate,
  saveEventEmailContent,
  registerEventNonMember,
  getBlastHistory,
  getBlastHistoryInfo,
  deleteBlastHistory,
};
export default EventController;
